module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_cancel.ba391.png";